<template>
  <v-app>
    <v-toolbar color="white">
      <v-toolbar-title>
        <router-link to="/">warrantyjar</router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-spacer></v-spacer>

      <v-menu bottom left>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item v-for="(item, i) in items" :key="i" @click="menuAction">
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar>

   <v-content>
      <section>
      <router-view />
      </section>
    </v-content>

    <v-footer color="blue darken-2">
      <v-layout row wrap align-center>
        <v-flex xs12>
          <div class="white--text ml-4">
            Made with
            <v-icon class="red--text">mdi-heart</v-icon>by
            <a class="white--text" href="https://vuetifyjs.com" target="_blank">Vuetify</a>
            and
            <a class="white--text" href="https://github.com/vwxyzjn">Costa Huang</a>
          </div>
        </v-flex>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
import Home from "./components/Home";
import Warranties from "./components/Waranties";

export default {
  name: "App",

  components: {
    Home,
    Warranties
  },

  data: () => ({


    showSearch:false,

    items: [{ title: "Preferences" }, { title: "Log out" }]
  }),

  methods: {
    menuAction() {
      this.$router.push("/");
    }
  }
};
</script>


<style >
.router-link-active {
  text-decoration: none;
}
</style>
